import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { login } from '../actions/AppActions';
import Logo from '../assets/images/logo-ontest.png';
import BgAssessments from '../assets/images/bg_admin_assessments.png';
import LoginScreen from './LoginScreen';
import { requestAdminAuthentication } from './adminAuthService';

export class Login extends React.Component {
    state = {
        loading: false, resending: false, msgErro: '', notice: '',
        credencial: '', password: '', challenge: null,
        code: Array(6).fill(''), resendAt: 0, seconds: 0,
        redirect: false, path: '',
    };

    componentDidMount() {
        this.clock = setInterval(() => {
            if (this.state.challenge) {
                const seconds = Math.max(0, Math.ceil((this.state.resendAt - Date.now()) / 1000));
                if (seconds !== this.state.seconds) this.setState({ seconds });
            }
        }, 1000);
    }

    componentWillUnmount() { clearInterval(this.clock); }

    credentials = () => ({ credencial: this.state.credencial, password: this.state.password });

    enterCode = (challenge) => {
        const seconds = Math.max(60, Number(challenge.resend_after) || 0);
        this.setState({ challenge, code: Array(6).fill(''), resendAt: Date.now() + seconds * 1000, seconds, loading: false, resending: false, msgErro: '', notice: '' });
    };

    back = () => {
        if (this.state.loading || this.state.resending) return;
        this.setState({ challenge: null, code: Array(6).fill(''), password: '', msgErro: '', notice: '', seconds: 0 });
    };

    submit = async (event) => {
        event.preventDefault();
        if (this.state.loading || this.state.resending) return;
        const challenge = this.state.challenge;
        if (challenge && this.state.code.some(character => !character)) return;
        this.setState({ loading: true, msgErro: '', notice: '' });
        try {
            const result = await requestAdminAuthentication(challenge ? 'two-factor/verify' : 'login', {
                ...this.credentials(),
                ...(challenge ? { challenge_id: challenge.challenge_id, code: this.state.code.join('') } : {}),
            });
            if (result.two_factor_required) { this.enterCode(result); return; }
            if (!result.access_token || typeof result.access_token !== 'string') throw new Error('O servidor não concluiu o acesso. Tente novamente.');
            localStorage.setItem('token', result.access_token);
            this.setState({ password: '', code: Array(6).fill('') });
            this.props.login({ token: result.access_token, user: {} });
        } catch (error) {
            this.setState({
                loading: false,
                msgErro: error.message || 'Não foi possível conectar ao servidor.',
                ...(error.type === 'invalid_credentials' ? { challenge: null, password: '', code: Array(6).fill(''), seconds: 0 } : {}),
            });
        }
    };

    resend = async () => {
        if (this.state.loading || this.state.resending || this.state.seconds > 0) return;
        this.setState({ resending: true, msgErro: '', notice: '' });
        try {
            const result = await requestAdminAuthentication('two-factor/resend', { challenge_id: this.state.challenge.challenge_id });
            this.enterCode(result);
            this.setState({ notice: 'Novo código enviado. Confira também a pasta de spam.' });
        } catch (error) {
            const seconds = error.retryAfter;
            this.setState({ resending: false, msgErro: error.message,
                ...(seconds ? { seconds, resendAt: Date.now() + seconds * 1000 } : {}),
                ...(error.type === 'invalid_credentials' ? { challenge: null, password: '', code: Array(6).fill('') } : {}),
            });
        }
    };

    render() {
        const { challenge, code, seconds, resending } = this.state;
        return <>
            {this.state.redirect && <Redirect to={this.state.path} />}
            <LoginScreen
                logo={Logo}
                kicker="Ambiente administrativo"
                background={BgAssessments}
                heroTitle="Gestão de avaliações com clareza e segurança."
                heroDescription="Organize processos, candidatos, fiscais e resultados em um painel moderno e direto."
                credential={this.state.credencial}
                password={this.state.password}
                onCredentialChange={event => this.setState({ credencial: event.target.value })}
                onPasswordChange={event => this.setState({ password: event.target.value })}
                onSubmit={this.submit}
                error={this.state.msgErro}
                submitting={this.state.loading}
                notice={this.state.notice}
                verification={challenge ? { code, seconds, resending, email: challenge.masked_email,
                    onChange: value => this.setState({ code: value, msgErro: '' }), onResend: this.resend, onBack: this.back } : null}
            />
        </>;
    }
}

export default connect(() => ({}), { login })(Login);
